<template>
  <div class="sales-mes-details public-content">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">业务主管信息</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="业务主管:">
          <el-input v-model="basicInfo.fullName"></el-input>
        </el-form-item>
        <el-form-item label="手机号:"> {{ basicInfo.phone }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" @click="onSubmit" round>保存</el-button>
    </div>
  </div>
</template>
<script>
import { getSalemanById, salesmanManagerUpdate } from '@/api/crm'
export default {
  name: 'supervisor-mes-details',
  data () {
    return {
      basicInfo: {
        fullName: '',
        phone: ''
      }
    }
  },
  created () {
    this.getSaleMsg()
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    onSubmit () {
      let editSalesmanVo = {
        fullName: this.basicInfo.fullName,
        id: this.basicInfo.id
      }
      salesmanManagerUpdate(editSalesmanVo).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        }
      })
    },
    getSaleMsg () {
      getSalemanById(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.basicInfo = res.data.data
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index.less";
@deep: ~">>>";
</style>
